import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {IonFab, IonFabButton, IonHeader, IonIcon, IonPage} from "@ionic/react";
import {StyledIonContent, StyledIonTitle, StyledIonToolbar} from "@components/content/content.style";
import {add} from 'ionicons/icons';
import AvailabilityPane, {AvailabilityPaneHandle} from "@app/availabilityPage/panes/availabilityPane.component";

const AvailabilityPage: React.FC = () => {
    const {t} = useTranslation();

    const header = useRef<HTMLIonHeaderElement>(null);
    const availabilityPaneRef = useRef<AvailabilityPaneHandle>(null);

    const [topEdge, updateTopEdge] = useState<number | undefined>(undefined);

    useEffect(() => {
        updateHeight();
    }, []);

    const updateHeight = () => {
        if (header.current?.clientHeight === 0) {
            setTimeout(updateHeight);
        } else {
            updateTopEdge(header.current?.clientHeight);
        }
    };

    const handleOpenNewAvailabilityModal = () => {
        availabilityPaneRef.current?.openAvailabilityAddModal();
    }

    return (
        <IonPage>
            <StyledIonContent>
                <IonHeader ref={header} className="ion-no-border">
                    <StyledIonToolbar>
                        <StyledIonTitle className="left">{t("profileTab.optionAvailability")}</StyledIonTitle>
                    </StyledIonToolbar>
                </IonHeader>
                <AvailabilityPane ref={availabilityPaneRef} topEdge={topEdge}/>
                <IonFab slot="fixed" vertical="bottom" horizontal="end"
                        style={{marginBottom: 'calc(95px + var(--ion-safe-area-bottom, 0px))'}}>
                    <IonFabButton onClick={() => handleOpenNewAvailabilityModal()}>
                        <IonIcon icon={add}/>
                    </IonFabButton>
                </IonFab>
            </StyledIonContent>
        </IonPage>
    );
};

export default AvailabilityPage;
